/**
 * Output Firestore Converter (Client SDK)
 *
 * Client-side converter for use with firebase/firestore (NOT firebase-admin).
 * Converts between Output TypeScript type and Firestore data.
 *
 * Based on strategyConverter pattern from firebase-core module.
 *
 * CRITICAL: Uses Client SDK signature fromFirestore(snapshot, options)
 * NOT Admin SDK signature fromFirestore(data)
 *
 * Note: Output entity has minimal fields (only id), but follows same pattern
 */

import { FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore';
import type { Output } from '@segmently/schema-models/entities';

export const outputConverter: FirestoreDataConverter<Output> = {
  /**
   * Convert Output model to Firestore data
   * Called when writing to Firestore (create, update operations)
   */
  toFirestore(output: Output): any {
    return { ...output };
  },

  /**
   * Convert Firestore data to Output model
   * Called when reading from Firestore (get, query, snapshot operations)
   *
   * CRITICAL: Uses Client SDK signature (snapshot, options) NOT Admin SDK signature (data)
   */
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options?: SnapshotOptions
  ): Output {
    // Extract data from snapshot using Client SDK method
    const data = snapshot.data(options);
    const result: any = { ...data };

    // Add document ID to result
    result.id = snapshot.id;

    return result as Output;
  }
};

export default outputConverter;
